import * as Events from '@core/events';

export const handler = ({
  field,
  data,
}: Pick<Events.TEventInformation<unknown>, 'field' | 'data'>) => {
  field.data.changed = true;
  field.data.metadata = data.metadata;
  field.value = data.parsedEventValue;
};
